module.exports = __webpack_public_path__ + "static/media/githubDark.c2c117b4.svg";